var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75,9.75c0,4.971-4.029,9-9,9S.75,14.721.75,9.75,4.779.75,9.75.75s9,4.029,9,9ZM14.687,9.01c0,2.727-2.211,4.937-4.937,4.937s-4.937-2.211-4.937-4.937,9.875-2.727,9.875,0ZM14.687,8.772c0,2.727-9.875,2.727-9.875,0",
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCups);
export default __webpack_public_path__ + "static/media/cups.ec39e64751f275f58e9abaa5fe094a3c.svg";
export { ForwardRef as ReactComponent };